/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationAssetControllerUpload202Response
 */
export interface OrganizationAssetControllerUpload202Response {
    /**
     * 
     * @type {string}
     * @memberof OrganizationAssetControllerUpload202Response
     */
    importRequestId: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAssetControllerUpload202Response
     */
    uploadedFileId: string;
}

/**
 * Check if a given object implements the OrganizationAssetControllerUpload202Response interface.
 */
export function instanceOfOrganizationAssetControllerUpload202Response(value: object): value is OrganizationAssetControllerUpload202Response {
    if (!('importRequestId' in value) || value['importRequestId'] === undefined) return false;
    if (!('uploadedFileId' in value) || value['uploadedFileId'] === undefined) return false;
    return true;
}

export function OrganizationAssetControllerUpload202ResponseFromJSON(json: any): OrganizationAssetControllerUpload202Response {
    return OrganizationAssetControllerUpload202ResponseFromJSONTyped(json, false);
}

export function OrganizationAssetControllerUpload202ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationAssetControllerUpload202Response {
    if (json == null) {
        return json;
    }
    return {
        
        'importRequestId': json['importRequestId'],
        'uploadedFileId': json['uploadedFileId'],
    };
}

export function OrganizationAssetControllerUpload202ResponseToJSON(json: any): OrganizationAssetControllerUpload202Response {
    return OrganizationAssetControllerUpload202ResponseToJSONTyped(json, false);
}

export function OrganizationAssetControllerUpload202ResponseToJSONTyped(value?: OrganizationAssetControllerUpload202Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'importRequestId': value['importRequestId'],
        'uploadedFileId': value['uploadedFileId'],
    };
}

